/*
  Luffka - colour dots for the compact "pair it with" card.

  The product-page upsell card (product_upsell-block--product-info) sits on
  one line next to the quantity stepper, where its native colour <select>
  does not fit. This script puts a row of small colour dots in its place,
  one per option value, and drives the hidden <select> from them: a tap sets
  select.value and fires a bubbling change event, so the theme's own upsell
  code updates the variant id and price exactly as if the select was used.

  Colours come from data-lfk-swatches on the card (the product's
  custom.variants metafield, e.g. "#670626, #C0C0C0", in option order),
  written by snippets/upsell-block.liquid. A card without that attribute,
  or a select with a different number of options, is left alone.

  The dots stop their click from reaching the card, which is itself a
  toggle (toggle_element: container) - choosing a colour must not tick or
  untick the offer.

  Safety: without this script the select stays visible and works as before.
*/
(() => {
  const build = (card) => {
    const picker = card.querySelector('.upsell__variant-picker');
    const select = picker && picker.querySelector('select');
    if (!select || picker.classList.contains('lfk-has-dots')) return;

    const colours = (card.dataset.lfkSwatches || '')
      .split(',')
      .map((c) => c.trim())
      .filter(Boolean);
    const options = [...select.options];
    if (!colours.length || colours.length !== options.length) return;

    const row = document.createElement('div');
    row.className = 'lfk-upsell-dots';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', select.name.replace(/^options\[|\]$/g, ''));

    const sync = () => {
      row.querySelectorAll('button').forEach((b) => {
        const on = b.dataset.value === select.value;
        b.setAttribute('aria-checked', String(on));
      });
    };

    options.forEach((opt, i) => {
      if (opt.disabled) return;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'lfk-upsell-dot';
      b.dataset.value = opt.value;
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', opt.value);
      b.title = opt.value;
      b.style.setProperty('--lfk-dot', colours[i]);
      b.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      row.appendChild(b);
    });

    select.addEventListener('change', sync);
    picker.appendChild(row);
    picker.classList.add('lfk-has-dots');
    sync();
  };

  const run = () =>
    document
      .querySelectorAll('.product-info-upsells-container product-info-upsell[data-lfk-swatches]')
      .forEach(build);

  // The product section re-renders on variant change; rebuild after it.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      queued = false;
      run();
    }, 60);
  }).observe(document.body, { childList: true, subtree: true });
  run();
})();
